<template>
  <Modal>
    <h2 slot="header" class="modal-title">
    {{$t('loadQuery.title')}}
    </h2>
    <div slot="body">
    <ul class="list-group">
      <li class="list-group-item" v-for="(savedQuery, index) in savedQueries" :key='index'><a href="#" @click="loadQueryById(savedQuery.id)">{{savedQuery.name}}</a><a style="float:right" href="#" class="removeQuery" @click="removeQueryById(savedQuery.id)">{{$t('loadQuery.remove')}}</a></li>
    </ul>
    </div>
    <div slot="footer">
    <button type="button" class="btn btn-secondary" @click="closeLoadQueryModal()"> {{$t('loadQuery.cancel')}} </button>
    </div>
  </Modal>
</template>

<script>
  import Modal from './Modal'
  import axios from 'axios'

  export default {
    name: 'LoadQuery',
    components: {Modal},
    props: { 
      search: Object
    },
    created () {
      this.loading = true
      axios.get(this.$store.state.user.url + '/queries', {headers: {'Authorization': 'Bearer ' + this.$store.state.user.token}})
        .then(response => {
          this.loading = false
          this.savedQueries = response.data
          console.log(response)
        })
        .catch(err => {
          console.error(err)
          this.$router.push(
            {name: 'Forbidden'}
          )
        })
    },
    computed: {
    },
    data() {
      return {
        savedQueries: []
      }
    },
    updated() {
    },
    methods: {
      closeLoadQueryModal: function () {
        this.$emit('closeModal')
      },
      loadQueryById: function (queryId) {
        axios.get(this.$store.state.user.url + '/queries/' + queryId, {headers: {'Authorization': 'Bearer ' + this.$store.state.user.token}})
          .then(response => {
            this.loading = false
            this.$emit('addQuery', JSON.parse(response.data.query), response.data.name, response.data.id)
            //this.addQuery(JSON.parse(response.data.query), response.data.name, response.data.id)
            console.log(response)
            this.$emit('closeModal')
          })
          .catch(err => {
            console.error(err)
            this.$router.push(
              {name: 'Forbidden'}
            )
          })
      },
      removeQueryById: function (queryId) {
        axios.delete(this.$store.state.user.url + '/queries/' + queryId, {headers: {'Authorization': 'Bearer ' + this.$store.state.user.token}})
          .then(response => {
            this.savedQueries = this.savedQueries.filter(q => q.id !== queryId)
          })
          .catch(err => {
            console.error(err)
            this.$router.push(
              {name: 'Forbidden'}
            )
          })
      }
    },
    watch : {
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/load_query.sass"
</style>
